import { Fragment } from 'react'
import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IWidgetHintProps = {
  items: string[]
}

export const WidgetHint = ({ items }: IWidgetHintProps) => {
  return (
    <Typography
      variant={'body-sm-regular'}
      ariaLabel={'WidgetHint'}
      className={styles.hint}
      tag={'div'}
    >
      {items.map((item, i) => (
        <Fragment key={item}>
          {i > 0 && <div className={styles.dot} />}
          <span>{item}</span>
        </Fragment>
      ))}
    </Typography>
  )
}
